import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '../../utils';
import { Users, Building2, Clock, Calendar, ArrowRight } from 'lucide-react';

export default function HRISQuickActions() {
  const quickActions = [
    { label: 'Data Pegawai', icon: Users, link: 'EmployeeList', color: 'bg-emerald-500' },
    {
      label: 'Struktur Organisasi',
      icon: Building2,
      link: 'OrganizationStructure',
      color: 'bg-blue-500',
    },
    { label: 'Absensi', icon: Clock, link: 'AttendanceList', color: 'bg-amber-500' },
    { label: 'Cuti', icon: Calendar, link: 'LeaveList', color: 'bg-purple-500' },
  ];

  return (
    <div className="bg-white rounded-lg border shadow-sm">
      <div className="p-6 pb-2">
        <h3 className="text-lg font-semibold">Akses Cepat</h3>
      </div>
      <div className="p-6 pt-0 space-y-2">
        {quickActions.map(action => (
          <Link key={action.link} to={createPageUrl(action.link)}>
            <button className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-colors">
              <div className="flex items-center gap-3">
                <div
                  className={`w-8 h-8 rounded-lg ${action.color} flex items-center justify-center`}
                >
                  <action.icon className="w-4 h-4 text-white" />
                </div>
                <span>{action.label}</span>
              </div>
              <ArrowRight className="w-4 h-4 text-gray-400" />
            </button>
          </Link>
        ))}
      </div>
    </div>
  );
}
